module.exports = __webpack_public_path__ + "5b4a0d5cee003f64e499c69f98ab2437.pdf";